<template>
  <v-snackbar
    :timeout="6000"
    v-model="snackbar"
    :color="snackbarColor"
  >
    {{ snackbarText }}
    <v-btn dark flat @click.native="snackbar = false">Close</v-btn>
  </v-snackbar>
</template>

<script>
export default {
  name: 'snackbar',
  data: function () {
    return {
      snackbar: false,
      snackbarColor: '',
      snackbarText: ''
    }
  },
  methods: {
    open: function (color, text) {
      this.snackbarColor = color
      this.snackbarText = text
      this.snackbar = true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Snackbar.vue